import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import './styles.css';

export const IconOrAvatar = ({ type, image, icon, name }) => {
  switch (type) {
    case 'hs':
    case 'he':
      return <Avatar size="small" institutionType={type} image={image} />;
    case 'person':
      return <Avatar user fullName={name} size="small" image={image} />;
    default:
      return <Icon icon={icon} />;
  }
};

IconOrAvatar.propTypes = {
  type: PropTypes.oneOf(['he', 'hs', 'person', 'other']),
  image: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string,
};

const SearchResultRenderer = ({ title, id, active, image, icon, description, type }) => (
  <div role="option" aria-selected={active} key="content" id={`global-search-box-item-${active ? 'active' : id}`}>
    <span styleName="search-avatar">
      <IconOrAvatar type={type} icon={icon} name={title} image={image} />
    </span>
    <div styleName="item">
      {title && <div className="title">{title}</div>}
      {description && <div className="description">{description}</div>}
    </div>
  </div>
);
SearchResultRenderer.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
};

export default SearchResultRenderer;
